(function (){
    'use strict';

    angular
        .module('services')
        .service('AgentBranchesService', AgentBranchesService);

    AgentBranchesService.$inject = ['$http', 'API_BASE'];

    function AgentBranchesService ($http, API_BASE) {
        var service = this;


        service.getBranches           = getBranches;



        function getBranches (request) {

            return $http.get(API_BASE + '/agents/branches/list',{params:request});
        }

    }
})();